import { RawMaterial_MaterialInwardTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState } from "react";
import { LiaSearchPlusSolid, LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import {
  materialInward,
  rawMaterials,
  supplierDieAPI,
  Unit,
} from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Model from "../../common/Model";
import FormFields from "../../common/FormFields";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import EntityAddModal from "../../common/EntityAddModal";
import { formatDate } from "../../utlis/formateDate";
import { RegistryHeader, Button as SharedButton } from "../../common/Shared";
import { TourGuide } from "../../components/TourGuide/TourGuide";
import { Info } from "lucide-react";

import MaterialInwardForm from "./MaterialInwardForm";

const MaterialInward = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const today = new Date().toISOString()?.split("T")[0];
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    inward_No: 0,
    inward_Date: today,
    skU_No: "",
    supplier_Id: "",
    material_Id: "",
    weight_Sleep1: "",
    weight_Sleep2: "",
    quantity: "",
    unit_Id: "",
    rate: "",
    origin: "",
    invoice_No: "",
    grade: "",
    batch_No: "",
    vehicle_No: "",
    notes: "",
    image_Upload: null,
    created_By: userId,
  });

  const [loading, setLoading] = useState(false);
  const [isMaterialInwardData, setIsMaterialInwardData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSupplierData, setIsSupplierData] = useState([]);
  const [isRawMaterialData, setIsRawMaterialData] = useState([]);
  const [isUnitData, setIsUnitData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(50);
  const [modalType, setModalType] = useState(null);
  const tableScrollRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const isFetchingRef = useRef(false);

  const [isTourOpen, setIsTourOpen] = useState(false);

  const handleTourComplete = () => {
    localStorage.setItem("aluex_mi_tour_seen", "true");
  };

  const fetchInwardData = async () => {
    if (isFetchingRef.current) return;
    setLoading(true);
    try {
      const res = await materialInward.getAllmaterialInward(
        currentPage,
        pageSize,
      );
      if (currentPage === 1) {
        setIsMaterialInwardData(res.items || []);
      } else {
        setIsMaterialInwardData((prev) => [...prev, ...(res.items || [])]);
      }

      if (!res.items || res.items.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }

      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching die master data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || !hasMore || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 120) {
        isFetchingRef.current = true;
        setCurrentPage((p) => p + 1);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [rawMaterialRes, supplierRes, unitRes] = await Promise.all([
          rawMaterials.getAll(),
          supplierDieAPI.getAll(),
          Unit.getAll(),
        ]);

        setIsRawMaterialData(
          Array.isArray(rawMaterialRes)
            ? rawMaterialRes
            : rawMaterialRes?.data || [],
        );

        const supplierArray = Array.isArray(supplierRes?.data)
          ? supplierRes.data
          : [];
        setIsSupplierData(supplierArray);

        setIsUnitData(Array.isArray(unitRes) ? unitRes : unitRes?.data || []);
      } catch (error) {
        notify("Error fetching dropdown data", "error");
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    fetchInwardData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isMaterialInwardData);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = isMaterialInwardData.filter((d) => {
        return (
          d.skU_No?.toLowerCase().includes(query) ||
          d.supplier_Name?.toLowerCase().includes(query) ||
          d.material_Name?.toLowerCase().includes(query) ||
          d.invoice_No?.toLowerCase().includes(query) ||
          d.vehicle_No?.toLowerCase().includes(query) ||
          d.origin?.toLowerCase().includes(query) ||
          d.grade?.toLowerCase().includes(query) ||
          d.batch_No?.toLowerCase().includes(query) ||
          d.notes?.toLowerCase().includes(query)
        );
      });
      setFilteredData(filtered);
    }
  }, [searchQuery, isMaterialInwardData]);

  const handleInputChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleAdd = () => {
    setIsEditing(false);
    setFormData({
      inward_No: 0,
      inward_Date: today,
      skU_No: "",
      supplier_Id: "",
      material_Id: "",
      weight_Sleep1: "",
      weight_Sleep2: "",
      quantity: "",
      unit_Id: "",
      rate: "",
      origin: "",
      invoice_No: "",
      grade: "",
      batch_No: "",
      vehicle_No: "",
      notes: "",
      image_Upload: null,
      created_By: userId,
    });
    setIsModelOpen(true);
  };

  const handleEdit = async (id) => {
    setLoading(true);
    try {
      const data = await materialInward.getById(id);

      if (data) {
        setFormData({
          inward_No: data.inward_No,
          inward_Date: data.inward_Date?.split("T")[0],
          skU_No: data.skU_No,
          supplier_Id: data.supplier_Id,
          material_Id: data.material_Id,
          weight_Sleep1: data.weight_Sleep1,
          weight_Sleep2: data.weight_Sleep2,
          quantity: data.quantity,
          unit_Id: data.unit_Id,
          rate: data.rate,
          origin: data.origin,
          invoice_No: data.invoice_No,
          grade: data.grade,
          batch_No: data.batch_No,
          vehicle_No: data.vehicle_No,
          notes: data.notes,
          image_Upload: data.image_Upload,
          created_By: userId,
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (error) {
      notify("Failed to fetch location details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await materialInward.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchInwardData();
    } catch (error) {
      notify("Failed to delete record", "error");
    } finally {
      setLoading(false);
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };

  const handleSubmit = async ({ resetOnly = false }) => {
    setIsSaving(true);
    try {
      const payload = {
        ...formData,
        material_Id: parseInt(formData.material_Id),
        supplier_Id: parseInt(formData.supplier_Id),
        unit_Id: parseInt(formData.unit_Id),
      };
      await materialInward.saveOrUpdate(payload);
      notify(
        isEditing ? "Updated successfully" : "Added successfully",
        "success",
      );
      fetchInwardData();

      if (resetOnly) {
        // Reset form for next entry
        setFormData({
          inward_No: 0,
          inward_Date: today,
          skU_No: "",
          supplier_Id: "",
          material_Id: "",
          weight_Sleep1: "",
          weight_Sleep2: "",
          quantity: "",
          unit_Id: "",
          rate: "",
          origin: "",
          invoice_No: "",
          grade: "",
          batch_No: "",
          vehicle_No: "",
          notes: "",
          image_Upload: null,
          created_By: userId,
        });
      } else {
        setIsModelOpen(false);
        setFormData({
          inward_No: 0,
          inward_Date: today,
          skU_No: "",
          supplier_Id: "",
          material_Id: "",
          weight_Sleep1: "",
          weight_Sleep2: "",
          quantity: "",
          unit_Id: "",
          rate: "",
          origin: "",
          invoice_No: "",
          grade: "",
          batch_No: "",
          vehicle_No: "",
          notes: "",
          image_Upload: null,
          created_By: userId,
        });
        setIsEditing(false);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleEntityAddSuccess = async (type, newOption) => {
    const config = {
      supplier: {
        setter: setIsSupplierData,
        fetcher: supplierDieAPI.getAll,
        setField: "supplier_Id",
      },
      rawMaterial: {
        setter: setIsRawMaterialData,
        fetcher: rawMaterials.getAll,
        setField: "material_Id",
      },
      unit: {
        setter: setIsUnitData,
        fetcher: Unit.getAll,
        setField: "unit_Id",
      },
    }[type];

    if (!config) return;

    try {
      const response = await config.fetcher();
      const items = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      config.setter(items);

      const newValue = newOption?.value || newOption?.id || newOption?.supplier_Id || newOption?.material_Id || newOption?.unit_Id || "";

      setFormData((prev) => ({
        ...prev,
        [config.setField]: newValue,
      }));
      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };

  if (isModelOpen) {
    return (
      <MaterialInwardForm
        formData={formData}
        isEditing={isEditing}
        isSaving={isSaving}
        onSave={handleSubmit}
        onCancel={() => {
          setIsModelOpen(false);
          setFormData(null);
          setIsEditing(false);
        }}
        isSupplierData={isSupplierData}
        isRawMaterialData={isRawMaterialData}
        isUnitData={isUnitData}
        handleInputChange={handleInputChange}
        onEntityAddSuccess={handleEntityAddSuccess}
      />
    );
  }

  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {loading && <Loader centered />}
      <RegistryHeader title="Material Inward">
        <div className="relative w-full sm:w-80 group">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-primary">
            <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
          </div>
          <input
            type="text"
            placeholder="Search by SKU / SUPPLIER / INVOICE..."
            className="block w-full pl-12 pr-10 py-2 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-primary focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
            >
              <MdClose size={18} />
            </button>
          )}
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => setIsTourOpen(true)}
            className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
            title="Page Guide"
          >
            <Info size={14} />
            Guide
          </button>
        </div>


        <div data-tour="mi-add">
          <SharedButton
            onClick={handleAdd}
            icon={HiOutlinePlus}
            className="whitespace-nowrap"
            loading={loading && currentPage === 1}
          >
            Add Material Inward
          </SharedButton>
        </div>
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col" data-tour="mi-table">
        <div
          ref={tableScrollRef}
          className="relative overflow-auto border border-gray-200 bg-white flex-1 "
        >
          <div className="min-w-max">
            <Table
              columns={[
                {
                  key: "inward_Date",
                  label: "DATE",
                  align: "center",
                  render: (value) => formatDate(value),
                },
                { key: "skU_No", label: "SKU NO", align: "center" },
                { key: "supplier_Name", label: "SUPPLIER", align: "center" },
                { key: "material_Name", label: "MATERIAL", align: "center" },
                { key: "quantity", label: "QTY", align: "center" },
                { key: "unit_Name", label: "UNIT", align: "center" },
                { key: "rate", label: "RATE", align: "center" },
                { key: "origin", label: "ORIGIN", align: "center" },
                { key: "invoice_No", label: "INVOICE NO", align: "center" },
                { key: "grade", label: "GRADE", align: "center" },
                { key: "batch_No", label: "BATCH", align: "center" },
                { key: "vehicle_No", label: "VEHICLE", align: "center" },
                { key: "notes", label: "REMARK", align: "center" },
              ]}
              data={filteredData}
              onEdit={(row) => handleEdit(row.inward_No)}
              onDelete={(row) => handleDelete(row.inward_No)}
              tableClassName="text-[12px] font-bold"
            />
          </div>
        </div>
      </div>

      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}

      <TourGuide
        isOpen={isTourOpen}
        onClose={() => setIsTourOpen(false)}
        steps={RawMaterial_MaterialInwardTourSteps}
        onComplete={handleTourComplete}
      />
    </div>
  );
};


export default MaterialInward;
